import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import axios from './../../axios';
import { isArray } from 'lodash';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const assessmentCreateSchema = z.object({
    student_id: z.string(),
    subject_id: z.string(),
});

const GenerateAssessment = ({ handleClose, studentInfo, setNewSelfAssment, setSelfAssessmentCreated }) => {
    let data = JSON.parse(localStorage.getItem("breathForStudent"));
    const teacherInformation = useSelector((state) => state.user.currentUser?.subject_information);
    const userId = useSelector((state) => state.user?.currentUser?.id);
    const [bookChapter, setBookChaptor] = useState({});
    const [books, setBooks] = useState([]);
    const [difficultyLevel, setDifficultyLevel] = useState([]);
    const [skill, setSkill] = useState([]);
    const [domain, setDomain] = useState([]);
    const navigate = useNavigate();

    const [assessmentCreateData, setAssessmentCreateData] = useState({
        name: null,
        student_id: userId,
        subject_id: null,
        type_id: "666909eb17f66bc584e226a0",
        status: "pending",
        standard_id: studentInfo.standard.id,
        section_id: studentInfo.section.id,
        book: null,
        chapter: null,
        knowledgeSkill: null,
        difficultyLevel: null,

    });
    const [selectSubject, setSelectedSubject] = useState(null);
    const [subjectsData, setSubjectsData] = useState([]);

    const getSubjects = () => {
        if (teacherInformation) {
            setSubjectsData([...teacherInformation]);
        }
    };

    const handleGenerateSelfAssessment = async () => {

        try {
            if (!assessmentCreateData.name) {
                toast.error('Please fille Self Assessement name');
                return false;
            }

            if (!assessmentCreateData.subject_id) {
                toast.error('Please select subject');
                return false;
            }
            let response = await axios.post(`/selfAssess/create`, assessmentCreateData);
            handleClose();
            setSelfAssessmentCreated(true)
        } catch (err) {
            let message = err?.response?.data?.message
            toast.error(message ?? "Something went wrong");
        }
    }

    const getDomain = async () => {
        try {
            let response = await axios.get(`/school/domain/get`);
            setDomain(response?.data?.data);
        } catch (err) {
            console.log("error", err)
        }
    }

    const getSkill = async () => {
        try {
            let response = await axios.get(`/school/skill/get`);
            setSkill(response?.data?.data)
        } catch (err) {
            console.log("error", err)
        }
    }

    const getDifficultyLevel = async () => {
        try {
            let response = await axios.get(`/difficultyLevel/get`);
            setDifficultyLevel(response?.data?.data);
        } catch (err) {
            console.log("error", err)
        }
    }

    const getBookAandChapter = async () => {
        try {
            let response = await axios.get(`/cm/library/book/getBookByClassSectionSubject?standard_id=${studentInfo.standard.id}&section_id=${studentInfo.section.id}&subject_id=${selectSubject}&timetableSessionId=${data?.timetable_session?.id}`);
            response = response?.data?.data;
            if (isArray(response)) {
                let bookCh = {};
                response[0].bookInfo.map((val) => {
                    bookCh[val.id] = val;
                })
                setBookChaptor(bookCh);
                setBooks(response[0].bookInfo);
            }

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getDomain();
        getSkill();
        getDifficultyLevel();
    }, [])

    useEffect(() => {
        if (selectSubject) {
            getBookAandChapter();
        }
    }, [selectSubject]);

    useEffect(() => {
        getSubjects();
    }, [teacherInformation]);
    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className='d-flex flex-column SubContainerSubmitedSucess'>
                <div className='d-flex justify-content-between'>
                    <div style={{ color: "orange" }}>
                        <p className='m-0'>Please Select the fields to  generate Self-Assessment </p>
                        <p className='m-0'>*Name and Subject is Mandatory</p>
                        <p className='m-0'>For unselected field, solution will auto-generate question intelligently.</p>
                    </div>
                    <div>
                        <img src="/StudentImg/BreathSchoolLogo.png" alt="logo" width="20" />
                    </div>
                </div>
                <div className='my-3'>
                    <label>Self-Assessment Name <span style={{ color: "red" }}>*</span> </label> &nbsp;
                    <input type="text" maxLength={100} className=' bg-transparent border-0 border-bottom w-75 outline-none' style={{ outline: "none" }} placeholder=' Please Enter Self-Assessment Name' onChange={(e) => setAssessmentCreateData((prev) => {
                        return { ...prev, name: e.target.value }
                    })} />
                </div>
                <div className='grid flex-wrap'>
                    <div className='row'>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="subject" defaultValue="0" onChange={(e) => {
                                setSelectedSubject(e.target.value); setAssessmentCreateData((prev) => {
                                    return { ...prev, subject_id: e.target.value == "0" ? null : e.target.value }
                                })
                            }}>
                                <option value="0">*Select Subject</option>
                                {
                                    subjectsData.map((subject, index) => <option key={subject.id} value={subject.id}>{subject.name}</option>)
                                }
                            </select>
                        </div>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="book" defaultValue="0" onChange={(e) => setAssessmentCreateData((prev) => {
                                return { ...prev, book: e.target.value == "0" ? null : e.target.value }
                            })}>
                                <option value="0">Select Book</option>
                                {
                                    books.map((book) => <option key={book.id} value={book.id}>{book.name}</option>)
                                }
                            </select>
                        </div>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="chapter" defaultValue="0" onChange={(e) => setAssessmentCreateData((prev) => {
                                return { ...prev, chapter: e.target.value == "0" ? null : e.target.value }
                            })}>
                                <option value="0">Select Chapter</option>
                                {
                                    assessmentCreateData?.book ? bookChapter[assessmentCreateData.book]?.chapterData.map((chapter) => <option key={chapter.id} value={chapter.id}>{chapter.chapterName}</option>) : null
                                }
                            </select>
                        </div>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="knowledgeSkill" defaultValue="0" onChange={(e) => setAssessmentCreateData((prev) => {
                                return { ...prev, knowledgeSkill: e.target.value == "0" ? null : e.target.value }
                            })}>
                                <option value="0">Select Knowledge Skill</option>
                                {skill.map((skl) => <option key={skl.id} value={skl.id}>{skl.name}</option>)}
                            </select>
                        </div>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="defficultyLevel" defaultValue="0" onChange={(e) => setAssessmentCreateData((prev) => {
                                return { ...prev, difficultyLevel: e.target.value == "0" ? null : e.target.value }
                            })}>
                                <option value="0">Select Difficulty Level</option>
                                {difficultyLevel.map((diffLevel) => <option key={diffLevel.id} value={diffLevel.id}>{diffLevel.name}</option>)}
                            </select>
                        </div>
                        <div className='col-4 mb-3'>
                            <select className="form-select" name="mcqQustionType" defaultValue="666909eb17f66bc584e226a0">
                                <option value="666909eb17f66bc584e226a0">MCQ</option>

                            </select>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-end mt-3'>
                    <button className='btn me-2' style={{ border: "1px solid orange" }} onClick={handleClose}>Cancel</button>
                    <button className='btn' disabled={!selectSubject || !assessmentCreateData.name} style={{ border: "1px solid orange" }} onClick={handleGenerateSelfAssessment}>Generate Self-Assessment</button>
                </div>
            </div>

        </div>
    )
}

export default GenerateAssessment